import type {
  InvenLikeListQueryVariables,
  InvenMyInfoQueryVariables,
  InvenPaidListQueryVariables,
  InvenRecentListQueryVariables,
  InvenRecommendListQueryVariables,
  SearchInvenListQueryVariables,
} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Inven 도메인 Query Key 관리
 */
export const INVEN_QUERY_KEY_MAP = {
  /**
   * 찜 목록 조회 (Infinite)
   * Origin: useInfiniteInvenLikeListQuery (getKey: ['invenLikeList.infinite', variables])
   */
  infiniteInvenLikeList: (variables: InvenLikeListQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'invenLikeList.infinite', variables] as const,

  /**
   * 유료 구매 목록 조회 (Infinite)
   * Origin: useInfiniteInvenPaidListQuery (getKey: ['invenPaidList.infinite', variables])
   */
  infiniteInvenPaidList: (variables: InvenPaidListQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'invenPaidList.infinite', variables] as const,

  /**
   * 최근 본 목록 조회 (Infinite)
   * Origin: useInfiniteInvenRecentListQuery (getKey: ['invenRecentList.infinite', variables])
   */
  infiniteInvenRecentList: (variables: InvenRecentListQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'invenRecentList.infinite', variables] as const,

  /**
   * 인벤 검색 목록 조회 (Infinite)
   * Origin: useInfiniteSearchInvenListQuery (getKey: ['searchInvenList.infinite', variables])
   */
  infiniteSearchInvenList: (variables: SearchInvenListQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'searchInvenList.infinite', variables] as const,

  /**
   * 내 인벤 정보 조회
   * Origin: useInvenMyInfoQuery.getKey
   */
  invenMyInfo: (variables?: InvenMyInfoQueryVariables) =>
    variables === undefined
      ? ([ADAPTER_QUERY_KEY_PREFIX, 'invenMyInfo'] as const)
      : ([ADAPTER_QUERY_KEY_PREFIX, 'invenMyInfo', variables] as const),

  /**
   * 추천 목록 조회
   * Origin: useInvenRecommendListQuery.getKey
   */
  invenRecommendList: (variables: InvenRecommendListQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'invenRecommendList', variables] as const,
} as const;

/**
 * Inven 도메인 Mutation Key 관리
 */
export const INVEN_MUTATION_KEY_MAP = {
  /**
   * 찜 목록 삭제
   * Origin: useDeleteInvenLikeMutation (getKey 없음)
   */
  deleteInvenLike: 'deleteInvenLike',
  /**
   * 유료 구매 목록 삭제
   * Origin: useDeleteInvenPaidMutation (getKey 없음)
   */
  deleteInvenPaid: 'deleteInvenPaid',

  /**
   * 최근 본 목록 삭제
   * Origin: useDeleteInvenRecentMutation (getKey 없음)
   */
  deleteInvenRecent: 'deleteInvenRecent',

  /**
   * 미리보기 열람
   * Origin: useOpenPreviewMutation (getKey: ['OpenPreview'])
   */
  openPreview: 'OpenPreview',
} as const;
